// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3_dzX","tab":"ProcedureTabs_tab__366Cv"};